<template>
  <div>
    <div class="row ma-0 mb-4">
      <h1 :style="{ color: $themes.primary, textTransform: 'uppercase' }">{{ title }}</h1>
    </div>

    <va-card class="flex md6 xs12">
      <form @submit.prevent="handleService">
        <div class="row ma-0">
          <file-upload v-model="service.photo" :error="!!errorsPhoto.length" :errorMessage="errorsPhoto" />
        </div>

        <div class="row ma-0">
          <div class="flex md6 xs12">
            <va-input
              label="Nome *"
              v-model="service.name"
              :error="!!nameErrors.length"
              :error-messages="nameErrors" />
          </div>
        </div>

        <div class="row ma-0">
          <div class="flex xs12">
            <text-area v-model="service.description" :error="!!errorsDescription.length" :errorMessage="errorsDescription"></text-area>
          </div>
        </div>

        <div class="row ma-0">
          <va-button outline color="danger" @click="$router.push({ name: 'services' })">Voltar</va-button>
          <va-button type="submit">{{ buttonText }}</va-button>
        </div>
      </form>
    </va-card>
  </div>
</template>

<script>
import api from '../api'
import FileUpload from '../components/FileUpload.vue'
import TextArea from '../components/TextArea.vue'

export default {
  data () {
    return {
      nameErrors: [],
      errorsPhoto: [],
      errorsDescription: [],
      service: {
        name: '',
        description: '',
        photo: '',
      },
    }
  },
  components: {
    FileUpload,
    TextArea,
  },
  computed: {
    title () {
      return this.$route.params.id
        ? 'Editar Serviço'
        : 'Novo Serviço'
    },

    buttonText () {
      return this.$route.params.id
        ? 'Editar'
        : 'Cadastrar'
    },
  },
  mounted () {
    if (this.$route.params.id) {
      api.get(`/service/${this.$route.params.id}`)
        .then(res => {
          this.service = res.data
        })
        .catch(err => console.log(err.message))
    }
  },
  methods: {
    handleService () {
      this.nameErrors = this.service.name ? [] : ['Nome é obrigatório']
      this.errorsPhoto = this.service.photo ? [] : ['Escolha uma imagem']
      this.errorsDescription = this.service.description ? [] : ['Campo obrigatório']

      if (this.nameErrors.length || this.errorsPhoto.length || this.errorsDescription.length) return

      // HERE CREATE serviço
      if (!this.$route.params.id) {
        api.post('/service', this.service)
          .then(res => {
            this.showToast('Serviço adicionado')

            this.$router.push({ name: 'services' })
          })
          .catch(err => console.log(err.message))
      } else {
        // HERE EDIT serviço
        api.put(`/service/${this.$route.params.id}`, this.service)
          .then(res => {
            this.showToast('Serviço atualizado')

            this.$router.push({ name: 'services' })
          })
          .catch(err => console.log(err.message))
      }
    },
  },
}
</script>
